import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../AccessControl/AccessControlTypes';
import { Data, NeoModel } from '@singularsystems/neo-core';
import ProvisionalTaxReportsSearchCriteria from '../Models/Queries/ProvisionalTaxReportsSearchCriteria';
import RealisedGainsSummaryLookup from '../Models/Lookups/RealisedGainsSummaryLookup';

export default class RealisedGainsSummaryVM extends Views.ViewModelBase {
  public provisionalTaxReportsSearchCriteria: ProvisionalTaxReportsSearchCriteria = new ProvisionalTaxReportsSearchCriteria();
  public realisedGainsSummaryPageManager = new Data.PageManager(this.provisionalTaxReportsSearchCriteria, RealisedGainsSummaryLookup,
     this.provisionalTaxReportsApiClient.getRealisedGainsSummaryPagedList, {
        pageSize: 10, 
        sortAscending: true,
        fetchInitial: false,
        sortBy: "eventDate",
        initialTaskRunner: this.taskRunner,
     }
   );

   constructor(
      taskRunner = AppService.get(Types.Neo.TaskRunner),
      private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
      private provisionalTaxReportsApiClient = AppService.get(Types.ApiClients.ProvisionalTaxReportsApiClient)) {
      super(taskRunner);
    }   

    public async initialise() {
    }

    public async search(searchCriteria: ProvisionalTaxReportsSearchCriteria) {
      this.provisionalTaxReportsSearchCriteria.mapFrom(searchCriteria);      
    }
}